import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let userMessage = null;

        if (error.status === 0) {
          userMessage = 'Network error. Please check your connection.';
        } else if (error.status >= 500) {
          userMessage = 'An unexpected error occurred. Please try again later.';
        }  else if (error.status >= 400 && error.status < 500) {}
        // Do NOT show session expired for 401 here
       if(userMessage){
        this.snackBar.open(userMessage, 'Close', {
          duration: 5000,
        });
       }
        // Log technical details for developers
        console.error('HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }
}
